import React from "react";
import * as PropTypes from "prop-types";
import { withStyles } from "@material-ui/core";
import styleConstants from "../../../styleConstants";

const styles = {
  container: {
    margin: "2rem 0 2rem"
  },
  description: {
    padding: "1rem 2rem 0"
  },
  reference: {
    fontSize: "4rem",
    fontWeight: styleConstants.fontWeights.bold,
    color: styleConstants.colors.themeBlueMedium
  },
  title: {
    marginBottom: "1rem",
    fontSize: "2.5rem",
    fontWeight: styleConstants.fontWeights.light
  }
};

const SimpleThemeIntroduction = props => (
  <div className={props.classes.container}>
    <div className={props.classes.title}>
      <span className={props.classes.reference}>{props.reference}</span>{" "}
      {props.title}
    </div>

    <div>{props.children}</div>
  </div>
);

SimpleThemeIntroduction.propTypes = {
  reference: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node)
  ]).isRequired
};

export default withStyles(styles)(SimpleThemeIntroduction);
